import React, { useState } from "react";
import { ShareApplicationPeopleTable } from "./ShareApplicationPeopleTable";
import { ShareApplicationInviteLink } from "./ShareApplicationInviteLink";
import { useShareApplicationWorkflow } from "./useShareApplicationWorkflow";
import { ShareApplicationPerson } from "@/types/ShareApplication";

export interface ShareApplicationWorkflowDialogProps {
  financialApplicationId?: string;
  onCoreDataRefresh?: () => Promise<void>;
}

export const ShareApplicationWorkflowDialog: React.FC<ShareApplicationWorkflowDialogProps> = ({
  financialApplicationId,
  onCoreDataRefresh,
}) => {
  const { people, isLoading, error, refetch } = useShareApplicationWorkflow(financialApplicationId);
  const [selectedPerson, setSelectedPerson] = useState<ShareApplicationPerson | null>(null);

  const handleShareClick = (person: ShareApplicationPerson) => {
    setSelectedPerson(person);
  };

  const handleBackToPeopleList = async () => {
    // Always refetch when going back to ensure we have the latest data
    await refetch();
    setSelectedPerson(null);
  };

  const handleUserLinked = async () => {
    // Refresh core data to update the applicantUserId
    if (onCoreDataRefresh) {
      await onCoreDataRefresh();
    }
    // Simply go back to the people list, which will trigger a refetch
    handleBackToPeopleList();
  };

  if (isLoading) {
    return <div>Loading people data...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {selectedPerson ? (
        <ShareApplicationInviteLink
          key={`invite-${selectedPerson.fullName}`}
          person={selectedPerson}
          financialApplicationId={financialApplicationId}
          onBack={handleBackToPeopleList}
          onUserLinked={handleUserLinked}
        />
      ) : (
        <>
          <h3>People to Share With</h3>
          <ShareApplicationPeopleTable people={people} onShareClick={handleShareClick} />
        </>
      )}
    </div>
  );
};

export default ShareApplicationWorkflowDialog;
